// import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import store from '../store'
import qs from 'qs'
import { MessageBox } from 'element-ui'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
  baseURL: process.env.VUE_APP_BASEURL,
  timeout: 300 * 1000 // Timeout
  // withCredentials: false // Check cross-site Access-Control
}
const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    config.headers['token'] = router.app.$cookies.get('token')
    if (config.type == 'formData') {
      config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
      config.data = qs.stringify(config.data)
    }
    switch (config[0]) {
      case 'form':
        config.data = qs.stringify(config.data)
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.status === 200) {
      switch (response.data.code) {
        case 0:
          return response.data
        case 1:
          router.app.$message({
            message: response.data.msg,
            type: 'warning'
          })
          break
        case '1000003':
          router.app.$message({
            message: response.data.msg,
            type: 'warning'
          })
          break
        case '1000002':
          router.app.$message({
            message: response.data.msg,
            type: 'warning'
          })
          break
        case 1001:
          // router.app.$router.push({
          //   path: '/login',
          //   query: {
          //     redirect: router.app.$route.fullPath
          //   }
          // })
          return MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            store.dispatch('FedLogOut').then(() => {
              location.reload()// 为了重新实例化vue-router对象 避免bug
            })
          })

        default:
          router.app.$message({
            message: response.data.msg,
            type: 'error',
            duration: 5 * 1000
          })
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 重新实例化
          })
      }
    } else if (response.status === 404) {
      router.app.$message({
        message: '接口不存在',
        type: 'error'
      })
    }
    return response
  },
  function (error) {
    console.log('失败的时候', error)
    // Do something with response error
    router.app.$message({
      message: '网络错误',
      type: 'warning'
    })
    return Promise.reject(error)
  }
)
// 2018-8-6
// Plugin.install = function (Vue, options) {
//   Vue.axios = _axios
//   window.axios = _axios
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get () {
//         return _axios
//       }
//     },
//     $axios: {
//       get () {
//         return _axios
//       }
//     }
//   })
// }

// Vue.use(Plugin)

export default _axios
